import { Link } from "react-router-dom";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";
import { cn } from "@/lib/utils";

const SellerAuthFooter = () => {
  const { isAndroid } = useSafeAreaInsets();

  return (
    <footer className={cn(
      "mt-auto py-8 border-t border-border",
      isAndroid ? "pb-8" : "pb-[calc(2rem+env(safe-area-inset-bottom))]"
    )}>
      <div className="container mx-auto px-4 text-center">
        <div className="text-muted-foreground text-sm mb-4">
          © {new Date().getFullYear()} Go Dyspo. All rights reserved.
        </div>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
              <Link 
                to="/consumer" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                Consumer Products
              </Link>
              <Link 
                to="/seller/faq" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                FAQ
              </Link>
              <Link 
                to="/contact" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                Contact Us
              </Link>
              <Link 
                to="/privacy-policy" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms-and-conditions" 
                className="text-muted-foreground hover:text-godyspo-gold transition-colors text-sm"
              >
                Terms & Conditions
              </Link>
        </div>
      </div>
    </footer>
  );
};

export default SellerAuthFooter;
